<template>
<div> 
    <a-form-item
        class="form-item"
        v-bind="formItemLayout"
        :validate-status="validateStatus"
        :help="help"
        hasFeedback v-if="type === '1'">
        <template slot="label">
          <span class="required">验证码</span>
        </template>
        <Input
          placeholder="请输入验证码"
          :value="value"
          @change="updateInputValue($event.target.value)"
        />
        <Button class="btnTime" v-if="yzmTime > 0" disabled>{{yzmTime}}秒后重发</Button>
        <Button class="btn" @click="resetCode" v-else>{{codeText}}</Button>
    </a-form-item> 
    <a-form-item label="验证码"
        class="form-item"
        :label-col="formItemLayout1.labelCol"
        :wrapper-col="formItemLayout1.wrapperCol"
        hasFeedback v-if="type === '2'">
        <Input v-decorator="['code',
        {
            rules: [{ required: true, message: '请输入验证码' }],
        }
        ]"
        placeholder="请输入验证码"
        />
        <Button class="btnTime" v-if="yzmTime > 0" disabled>{{yzmTime}}秒后重发</Button>
        <Button class="btn" @click="resetCode" v-else>{{codeText}}</Button>
    </a-form-item> 

</div>
      
</template>

<script>
  import CommonFramework from "@components/commonFramework/index";
  import { Input, Button } from 'ant-design-vue'
  import PopPanel from "@components/popPanel/index";
  import form from "../../../utils/form";
  import appConst from '@utils/constant';
  import base64 from 'js-base64';
  import api from '@utils/api';
  import {$http, http} from '@utils';
  import queryString from 'query-string';

  export default {
    name: "sendmobile",
    components: {CommonFramework, PopPanel, Input, Button},
    mixins: [ form ],
    props: {
        phone: {
            type: String,
            default: ''
        },
        value: {
            type: String,
            default: ''
        },
        validateStatus: {
            type: String,
            default: ''
        },
        help: {
            type: String,
            default: ''
        },
        isSendCode: {
            type: Boolean,
            default: false,
        },
        type: {
            type: String,
            default: '1', // 1：小施 2：小艳
        },
        serviceType: {
            type: String,
            default: 'LOGIN', 
        }
    },
    data () {
        return {
            yzmTime: 0,
            codeText: '短信验证码',
            formItemLayout1: {
                labelCol: {
                    xs: { span: 24 },
                    sm: { span: 8 },
                },
                wrapperCol: {
                    xs: { span: 24 },
                    sm: { span: 16 },
                },
            },
        }
    },
    mounted() {
    },
    computed: {
    },
    watch: {
        isSendCode: {
            async handler(newName, oldName) {
                // console.log('我是子组件watch', newName, '旧值', oldName)
                if (newName) {
                    const res = await this.sendPhoneMsg(this.phone)
                    if (res.code * 1 === 1) {
                        this.yzmTime = 60;
                        this.codeText = '再次获取'
                        this.$message.info('验证码已发送至手机，5分钟内输入有效，请勿泄漏！')
                        const t = () => {
                            setTimeout(() => {
                                this.yzmTime = this.yzmTime - 1;
                                if (this.yzmTime > 0) {
                                    t()
                                }
                            }, 1000);
                        }
                        t();
                        setTimeout(() => {
                            this.$emit('update:isSendCode', false) 
                        }, this.yzmTime * 1000); 
                    } else {
                        this.codeText = '再次获取'
                        this.$emit('update:isSendCode', false) 
                        this.$message.error(res.msg || '系统异常');
                    }
                } else {
                    console.log('no work')
                }
    　　     },
    　　    immediate: true
        }
    },
    methods: {
        getServiceType(v) {
            const _d = `APPSERVICECODE_${v}`
            return appConst[_d]
        },
        resetCode() {
            this.$emit('resetCode')
        },
        updateInputValue(value) {
            // 子组件的input值改变父组件传入的value
            this.$emit('update:value', value)
            this.$emit('checkCode')
        },
        // 发送短信验证码接口，验证码在后台查看
        async sendPhoneMsg(value) {
            // const serviceCode = `${appConst.APPSERVICECODE}`;
            // templateCode: 'ec2e53f454064cefad407a566224fa3f',   测试短信模板
            const serviceCode = this.getServiceType(this.serviceType)
            const _api = `${api.mainHost}/portal-api/user/sendPhoneMsg.do`
            const param = JSON.stringify({
                identity: `${value}`,
                serviceCode,
                templateCode: '1fe75683aa114861ab9100c1ebfacc41',
                sms: {
                    phone: `${value}`,
                    message: '',
                    params: ''
                }
            })
            const res = await http.post(_api, queryString.stringify({param}), {
                headers: {
                    'content-Type': 'application/x-www-form-urlencoded'
                }
            })
            return res   
        },
    }
  }
</script>
<style lang="scss" scoped>
$primary_dark_color: #1C7AE5;

    .pop-common-form .form-item input  {
        width: 150px;
    }
    
    .btn {
        font-family: MicrosoftYaHei;
        font-size: 13px;
        color: #116CD0;
        letter-spacing: 0;
        height: 38px;
        width: 100px;
        padding: 11px 13px;
        line-height: 1;
        margin-left: 10px;
        border: 1px solid $primary_dark_color;
        color: $primary_dark_color;    
    }

    .btnTime {
        color: #ccc;
        font-family: MicrosoftYaHei;
        font-size: 13px;
        letter-spacing: 0;
        height: 38px;
        width: 100px;
        padding: 11px 13px;
        line-height: 1;
        margin-left: 10px;
        border: 1px solid #ccc;
        color: #ccc;   
    }

</style>


